module.exports = __webpack_public_path__ + "static/media/home-hero--bg-scotland.f3e08b14.jpg";